import { Box, Stack } from "@mui/material";
import { Location } from "@/resources/types";
import { OptionsManager } from "../components/OptionsManager";
import { SettingsPageHeader, FloatingSaveButton } from "../components";
import { RecordEditDialog } from "../components/RecordEditDialog";
import { locationSchema, locationDuplicateCriteria } from "../components/schemas";
import { useSettingsState, useRecordEditor } from "../hooks";
import { LocationOccupancyAdminActions } from "./LocationOccupancyAdminActions";

export const Locations = () => {
  const {
    value: locations,
    setValue: setLocations,
    isDirty,
    isSaving,
    isLoading,
    save,
  } = useSettingsState<Location[]>({
    settingsPath: "locations",
    defaultValue: [],
  });

  const {
    editingRecord,
    handleEdit,
    handleEditSave,
    handleEditCancel,
    handleDelete,
  } = useRecordEditor<Location>({
    setRecords: setLocations,
    displayField: "name",
  });

  return (
    <Box sx={{ position: "relative", height: "100%", width: "100%", overflow: "hidden" }}>
      <Box sx={{ height: "100%", width: "100%", overflow: "auto", p: 3, pb: 10 }}>
        <Stack spacing={4} sx={{ width: "100%" }}>
          <SettingsPageHeader title="Locations" isDirty={isDirty} />

          <OptionsManager
            records={locations}
            onChange={setLocations}
            schemaDefinition={locationSchema}
            duplicateRecordCriteria={locationDuplicateCriteria}
            title="Locations"
            useAccordion={false}
            onEdit={handleEdit}
            onDelete={handleDelete}
            isLoading={isLoading}
            toolbarExtra={<LocationOccupancyAdminActions locations={locations} />}
          />
        </Stack>

        <RecordEditDialog
          open={editingRecord !== null}
          onClose={handleEditCancel}
          onSave={handleEditSave}
          record={editingRecord}
          schemaDefinition={locationSchema}
        />

        <FloatingSaveButton show={isDirty} onSave={save} isSaving={isSaving} />
      </Box>
    </Box>
  );
};
